// @flow

import * as React from 'react';

import type { ProductId } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base, ToggleGroup, TogglePill, Placeholder } from '@gandi/ui';

import { useFeatureFlags } from '../../../../../../hooks/useFeatureFlag';
import type { GandiFormSelectOption } from '../../types';

import LabelContent from './LabelContent';

type Props = {
  onChange: (evt: SyntheticInputEvent<>) => mixed,
  options?: Array<GandiFormSelectOption<number>>,
  value: number,
  detail?: React.Node,
  /** productId is used to generate a unique field id */
  productId: ProductId,
};

export default function PlanToggleGroupRow({
  onChange,
  options = [],
  value,
  detail,
  productId,
}: Props): React.MixedElement {
  const { FF_CART_OVERVIEW_NDS } = useFeatureFlags();

  const { __ } = useTranslator();
  const inputId = `plan-${productId}`;

  const pills = React.useMemo(
    () =>
      options.map(opt => (
        <TogglePill value={opt.value} key={opt.value}>
          {opt.text}
        </TogglePill>
      )),
    [options],
  );

  if (FF_CART_OVERVIEW_NDS) {
    /* TODO: Implement new design */
    return (
      <div>
        {options.length > 0 ? (
          <LabelContent htmlFor={inputId} label={__('Billing cycle')}>
            <ToggleGroup
              key={inputId}
              value={value}
              onChange={onChange}
              id={inputId}
            >
              {pills}
            </ToggleGroup>
          </LabelContent>
        ) : (
          <Placeholder />
        )}
        {!!detail && (
          <Base size="small" color="light">
            {detail}
          </Base>
        )}
      </div>
    );
  }

  // Legacy style
  return (
    <Base flex flexShrink0 gap="xsmall" marginBottom="xsmall">
      <span>
        {options.length > 0 ? (
          <LabelContent htmlFor={inputId} label={__('Billing cycle')}>
            <ToggleGroup
              key={inputId}
              value={value}
              onChange={onChange}
              id={inputId}
            >
              {pills}
            </ToggleGroup>
          </LabelContent>
        ) : (
          <Placeholder />
        )}
        {!!detail && (
          <Base marginTop="xxsmall" size="small" color="light">
            {detail}
          </Base>
        )}
      </span>
    </Base>
  );
}
